// extracted by mini-css-extract-plugin
export default {"title":"Kaa-z","warning":"Laa-z","sizeOptionsLegendText":"Maa-z"};